import * as React from 'react'
import ReactAccordion from '@mui/material/Accordion'
import ReactAccordionSummary from '@mui/material/AccordionSummary'
import ReactAccordionDetails from '@mui/material/AccordionDetails'
import CircledRightArrowIcon from 'components/Icons/CircledRightArrow'
import CircledUpArrowIcon from 'components/Icons/CircledUpArrow'

const ExpandIcon = ({ expanded }) => {
  return (
    expanded ? <CircledUpArrowIcon /> : <CircledRightArrowIcon />
  )
}

export default function Accordion ({ label, children, shouldHideBorderTop }) {
  const [isExpanded, setIsExpanded] = React.useState(false)

  const handleChange = (event, expanded) => {
    setIsExpanded(expanded)
  }

  return (
    <ReactAccordion
      sx={{
        boxShadow: 'none',
        '&:before': {
          display: shouldHideBorderTop ? 'none' : 'block'
        },
        '&.Mui-expanded': {
          margin: '0'
        },
        '&.Mui-expanded:before': {
          opacity: '1'
        }
      }}
      onChange={handleChange}
    >
      <ReactAccordionSummary
        sx={{
          minHeight: '64px',
          flexDirection: 'row-reverse',
          padding: 0,
          gap: '0.5rem',
          '& .MuiAccordionSummary-content': {
            margin: '1rem 0'
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '0'
          }
        }}
        expandIcon={<ExpandIcon expanded={isExpanded} />}
        aria-controls='panel1a-content'
      >
        {label}
      </ReactAccordionSummary>
      <ReactAccordionDetails sx={{ padding: '0 0.25rem 1rem' }}>
        {children}
      </ReactAccordionDetails>
    </ReactAccordion>
  )
}
